import * as React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";

// Derive the correct prop types from the provider component
type ThemeProviderProps = React.ComponentPropsWithoutRef<
  typeof NextThemesProvider
>;

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider {...props} data-oid="ld_ihvm">
      {children}
    </NextThemesProvider>
  );
}
